// Отправка запросов для форм-загрузчиков

import cookies from "../../../cookies";
import ApiRequest from "../../../api-request";

const getRequest = function (file) {
    let request = new FormData();
    request.append("document", file);
    return request;
};

const uploader = async function (url, file, progressHandler) {
    let request = getRequest(file);
    let api = new ApiRequest(url, { csrf: cookies.get("csrftoken") });
    return api.uploadFile(request, progressHandler);
};

export default {
    getRequest: getRequest,
    uploader: uploader,
};
